import React from 'react';
import { Navigate } from 'react-router-dom';

export const decideDirection = ({
	condition,
	Component,
	pathTo,
}: {
	condition: boolean;
	Component: React.FC | null;
	pathTo?: string;
}) => {
	if (!pathTo) return;

	return condition && Component
		? <Component />
		: <Navigate
			replace
			to={pathTo}
		/>;
};
